import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

const SESSION_KEY = "wut_session_id";

function getSessionId() {
  let id = localStorage.getItem(SESSION_KEY);
  if (!id) {
    id = (typeof crypto !== "undefined" && crypto.randomUUID)
      ? crypto.randomUUID()
      : `s_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(SESSION_KEY, id);
  }
  return id;
}

/**
 * Mounted once inside <BrowserRouter>. Fires a fire-and-forget tracking
 * call on every pathname change. Failures are swallowed silently — analytics
 * must never block UX.
 */
export default function PageViewTracker() {
  const location = useLocation();

  useEffect(() => {
    // Skip admin paths from being counted (avoid self-noise)
    if (location.pathname.startsWith("/admin")) return;
    const payload = {
      path: location.pathname,
      session_id: getSessionId(),
      referrer: document.referrer || "",
    };
    api.post("/analytics/track", payload).catch(() => {});
  }, [location.pathname]);

  return null;
}
